import React from 'react'
import { useTheme } from '../../contexts/ThemeContext'
import { Moon, Sun } from 'lucide-react'
import styled from 'styled-components'

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background-color: var(--card-bg);
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  
  &:hover {
    background-color: var(--card-border);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08);
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 20px;
    height: 20px;
    stroke-width: 2;
  }
`

const ThemeToggle = ({ className }) => {
  const { theme, toggleTheme } = useTheme()

  return (
    <ToggleButton
      type="button"
      onClick={toggleTheme}
      className={className}
      aria-label={`Alternar para tema ${theme === 'light' ? 'escuro' : 'claro'}`}
      title={`Alternar para tema ${theme === 'light' ? 'escuro' : 'claro'}`}
    >
      {theme === 'light' ? <Moon /> : <Sun />}
    </ToggleButton>
  )
}

export default ThemeToggle
